import { z } from 'zod/v4';

export const termsAndConditions = z.object({
  id: z.uuid(),
  version: z.number(),
});

export type TermsAndConditions = z.infer<typeof termsAndConditions>;

export const termsAndConditionsUserAcceptanceSchema = z.object({
  accepted: z.boolean(),
  message: z.string().nullable(),
  tcsExist: z.boolean(),
});

export type TermsAndConditionsUserAcceptance = z.infer<typeof termsAndConditionsUserAcceptanceSchema>;
